// extracted by mini-css-extract-plugin
export default {"label":"PersonalizationSummaryDownload_label__NcLQI","secondColumn":"PersonalizationSummaryDownload_secondColumn__R8n43"};